import React, { FC, Fragment, useEffect, useState } from "react";
import { Button, InputField, SelectField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import { MdCancel, MdDelete } from "react-icons/md";
import RatingBar from "../../forms/RatingBar";
import { FaAd, FaAngleDown, FaPlus } from "react-icons/fa";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { IoMdMore } from "react-icons/io";
import PreviewAppraisalTemplateModal from "./PreviewAppraisalTemplateModal";

interface QuestionDTO {
  question: string;
  responseType: string;
  id?: number;
  options?: string[];
}

interface ResponsePickerDTO {
  value: string;
  onChange: (v: any) => void;
}
export default ({ item, show , refresh}: any) => {
  var { control, handleSubmit, getValues, setValue } = useForm();

  const { setLoading } = useStateSetter();
  const [questions, setquestions] = useState<QuestionDTO[]>([]);
  const { SelectedOrg, config } = useStateGetter();
  const { getTempQuestions, AddTempQuestions, updateQuestion } =
    useAppraisalTempHook();
  const [, setRender] = useState(0); // Dummy state

  const getquest = async () => {
    setLoading(true);
    try {
      var quest = await getTempQuestions(item.id);
      setquestions(quest);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const ResponseTypePicker: React.FC<ResponsePickerDTO> = ({
    value,
    onChange,
  }: any) => {
    var responseTypes = ["text", "options", "ratings"];

    return (
      <div className="px-4  rounded-[10px] border border-gray-400  inline-block">
        <Menu as="div" className={`relative  `}>
          <Menu.Button className="flex justify-between text-gray-400 py-1  ">
            <p className="text-[10px] font-light">{value ? value : "Select"}</p>
            <FaAngleDown className=" inline" />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-left z-10 absolute left-0  rounded-sm shadow-md min-w-[100px] p-2 bg-white w-full     overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none">
              {responseTypes.map((item: any) => (
                <Menu.Item>
                  <p
                    onClick={() => {
                      onChange(item);
                    }}
                    className=" text-xs font-light w-full text-black  cursor-pointer truncate py-2 hover:bg-customGray "
                  >
                    {item}
                  </p>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    );
  };
  const onSubmit = async (data: any) => {
    console.log(data, questions);
    setLoading(true);
    await Promise.all(
      questions.map(async (quest, key) => {
        if (quest.id) {
          //updatequestion
          var postdata = {
            question:  getValues(`question${key}`),
            responseType: quest.responseType,
            options: quest.options,
         
          };
          try {
            var response = await updateQuestion(quest.id, postdata);
          } catch (e) {
            console.log(e);
          } finally {
          }
        } else {
          //addquestions
          var postdata_ = {
            question: getValues(`question${key}`),
            responseType: quest.responseType,
            options: quest.options,
            tempID: item.id,
            organizationID: SelectedOrg.id,
          };
          try {
            var response_ = await AddTempQuestions(postdata_);
          } catch (e) {
            console.log(e);
          }
        }
      })
    );
    toast("Template Updated")
    setLoading(false);
    refresh()
  };

  useEffect(() => {
    getquest();
  }, []);

  useEffect(() => {
    console.log(questions);
  }, [questions]);

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white min-w-[50vw] p-4  max-h-[90vh] overflow-y-scroll ">
          <div className="flex justify-between items-center my-2 ">
            <p className="font-semibold self-start   "> {item.name} </p>
            <MdCancel
              onClick={() => {
                show(false);
              }}
              size={20}
              className="text-gray-400 "
            />
          </div>{" "}
          <div>
            {questions.map((it: any, key: number) => (
              <div className="my-2">
                <span className="px-1 bg-textbg rounded text-xs  text-white ">
                  {key + 1}
                </span>{" "}
                <span className=" text-gray-700 text-xs inline">
                  {" "}
                  <InputField
                    name={`question${key}`}
                    title="Question title"
                    placeholder={"Enter question title"}
                    defaultvalue={it.question}
                    control={control}
                    rules={{
                      required: " required",
                      pattern: {
                        value: textReg,
                        message: "Invalid",
                      },
                    }}
                  />
                </span>
                <div className="mx-4">
                  {it.responseType == "ratings" && (
                    <RatingBar
                      name={`response`}
                      title="Response"
                      placeholder={"Response field"}
                      isDisabled={true}
                      control={control}
                      // rules={{
                      //   required: " required",
                      //   pattern: {
                      //     value: textReg,
                      //     message: "Invalid",
                      //   },
                      // }}
                    />
                  )}
                  {it.responseType == "text" && (
                    <InputField
                      name={`response`}
                      title="Response"
                      placeholder={"Response field"}
                      isDisabled={true}
                      control={control}
                      // rules={{
                      //   required: " required",
                      //   pattern: {
                      //     value: textReg,
                      //     message: "Invalid",
                      //   },
                      // }}
                    />
                  )}
                  {it.responseType == "options" && (
                    <SelectField
                      control={control}
                      name={`response`}
                      // rules={{ required: "required" }}
                      placeholder="Select"
                      title="Response"
                      options={it.options}
                    />
                  )}
                </div>
                <div className=" my-2 ">
                  <p className="text-xs text-gray-400 inline">Response Type:</p>{" "}
                  <ResponseTypePicker
                    value={it.responseType}
                    onChange={(v: any) => {
                      var prev_ = [...questions];
                      prev_[key].responseType = v;
                      prev_[key].options = v == "options" ? [""] : undefined;
                      console.log(prev_, "prev_");
                      setquestions(prev_);
                    }}
                  />
                </div>
                {/* options */}
                {it.options && (
                  <div>
                    <small className="text-[10px text-gray-400]">Options</small>{" "}
                    {it.options?.map((ik: string, key1: number) => (
                      <div>
                        <input
                          className="text-xs inline text-gray-500  border active:outline-none active:border p-1  border-gray-200 "
                          onChange={(e) => {
                            var prev_: QuestionDTO[] = [...questions];
                            if (prev_[key].options != undefined) {
                              prev_[key].options[key1] = e.target.value;
                              setquestions(prev_);
                            }
                          }}
                          value={it.options[key1]}
                        />
                        <MdCancel
                          onClick={() => {
                            var prev_: QuestionDTO[] = [...questions];
                            if (prev_[key].options != undefined) {
                              prev_[key].options = prev_[key].options.filter(
                                (h: any) => h != it.options[key1]
                              );
                              setquestions(prev_);
                            }
                          }}
                          className=" mx-1 text-gray-400 inline"
                        />
                      </div>
                    ))}
                    <small
                      className="text-[10px] cursor-pointer text-gray-500 py-1 px-2 border border-primary rounded mb-2 "
                      onClick={() => {
                        var prev_: QuestionDTO[] = [...questions];
                        if (prev_[key].options) {
                          prev_[key].options = prev_[key].options.concat([""]);
                          setquestions(prev_);
                        }
                      }}
                    >
                      <FaPlus className="inline " /> Add option
                    </small>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="flex justify-end my-3">
            <p
              className="text-primary text-sm cursor-pointer border rounded border-primary p-1"
              onClick={() => {
                setquestions((prev: QuestionDTO[]) =>
                  prev.concat([{ question: "", responseType: "text" }])
                );
              }}
            >
              <FaPlus className="inline" /> Add Question
            </p>
          </div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                show(false);
              }}
            />

            <Button text="Save Changes" onBtnClick={handleSubmit(onSubmit)} />
          </div>
        </div>
      </div>
    </>
  );
};
